/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './finderConst'], function ($, _, EventEmitter, FinderConst) {

    var defaultIconMarkerPath = './../Images/markers/defaultMarkerIcon.png';
    var activeIconMarkerPath = './../Images/markers/activeMarkerIcon.png';

    function FinderMarkers($finderContainer, mapInstace, markersConfig) {
        if (!mapInstace) {
            throw new Error('Markers require map instance');
        }
        this.$finderContainer = $finderContainer;
        this.mapInstace = mapInstace;
        this.markersConfig = markersConfig;
    }

    FinderMarkers.prototype = _.clone(EventEmitter.prototype);

    FinderMarkers.prototype.init = function () {

        this.$finderMarkers = this.$finderContainer.find(FinderConst.finderMarkersSelector);

        if (!this.$finderMarkers.length) return;
        
        this.markerDefaultIcon = {
            url: this.markersConfig.defaultIconMarkerPath || defaultIconMarkerPath
        };

        this.markerActiveIcon = {
            url: this.markersConfig.activeIconMarkerPath || activeIconMarkerPath
        };

        this.$markersItems = this.$finderMarkers.find(FinderConst.finderMarkersItems);

        this.markers = this.buildMarkers().toArray();

        this.markersArray = this.markers.map(function (item) {
            return item.markerMapReference;
        });

        this.bindEvents();

    };

    FinderMarkers.prototype.bindEvents = function () {

        var _this = this;

        this.$mobileToogleListButton = $(FinderConst.finderToggleListMobileButtonSelector);

        if (this.$mobileToogleListButton.length) {

            this.$mobileToogleListButton.off('click');

            this.$mobileToogleListButton.on({
                click: function () {

                    var $this = $(this);
                    $this.toggleClass('input-field--active');
                    _this.$finderMarkers.toggleClass('finder__markers--show');


                }
            })

        }

    };

    FinderMarkers.prototype.getMarkers = function (onlyReference) {
        return onlyReference ? this.markersArray : this.markers;
    };

    FinderMarkers.prototype.buildMarkers = function () {

        var _this = this;

        return this.$markersItems.map(function (index, contentMarker) {

            var $contentMarker = $(contentMarker);
            var lat = parseFloat($contentMarker.data('markerLat'));
            var lng = parseFloat($contentMarker.data('markerLon')); //@todo refacotr lon to lng in cms

            var iconDefault = $contentMarker.data('markerDefault') ? {
                    url: $contentMarker.data('markerDefault'),
                    size: new google.maps.Size(30, 41),
                    scaledSize: new google.maps.Size(30,41)
                } : undefined;

            var iconActive = $contentMarker.data('markerActive') ? {
                    url: $contentMarker.data('markerActive'),
                    size: new google.maps.Size(30, 41),
                    scaledSize: new google.maps.Size(30,41)
                } : undefined;

            if (!lat || !lng) return;

            var postCodes = $contentMarker.data('markerPostcode').toString();
            var countriesCodes = $contentMarker.data('markerCountriesCode').toString();

            var markerData = {
                contentDomReference: $contentMarker,
                position: {
                    lat: lat,
                    lng: lng
                },
                postCodes: postCodes,
                countriesCodes: countriesCodes,
                optimized: false,
                iconsSettings: {
                    iconDefault: iconDefault,
                    iconActive: iconActive
                }
            };

            var contentTitle;

            try {
                contentTitle = $contentMarker.find('[data-marker-title]').data('markerTitle')
            } catch (e) {

            }
            markerData.markerMapReference = new google.maps.Marker({
                title: $contentMarker.data('markerTitle') || contentTitle,
                position: {
                    lat: lat,
                    lng: lng
                },
                map: _this.mapInstace,
                contentId: $contentMarker.attr('id'),
                postCodes: postCodes,
                countriesCodes: countriesCodes,
                pc: postCodes,
                optimized: false,
                iconsSettings: {
                    iconDefault: iconDefault,
                    iconActive: iconActive
                }
            });

            // console.log('create google maps marker', markerData)

            _this.setMarkerIcon(markerData.markerMapReference, markerData.iconsSettings.iconDefault || _this.markerDefaultIcon);
            _this.bindMarkerEvents(markerData.markerMapReference);

            return markerData;

        })

    };

    FinderMarkers.prototype.bindMarkerEvents = function (markerReference) {

        var _this = this;

        markerReference.addListener('click', function () {

            _this.clearAllSelected();

            if (_this.activeMarker && _this.activeMarker == markerReference) {
                _this.emit('finder.markers.hideMarker');
                _this.setMarkerIcon(markerReference, markerReference.iconsSettings.iconDefault || _this.markerDefaultIcon);
                _this.activeMarker = undefined;
                return;

            }

            _this.activeMarker = markerReference;

            window.tracking.trackGTM({
                'event': 'map',
                'action': 'markerClick',
                'value': _this.activeMarker.title

            });

            window.tracking.trackGA([
                'send',
                'event',
                'map',
                'markerClick',
                _this.activeMarker.title
            ]);

            _this.emit('finder.markers.markerClicked', markerReference);

        });

        markerReference.addListener('mouseover', function () {

            // console.log('markerReference', markerReference);
            _this.setMarkerIcon(markerReference, markerReference.iconsSettings.iconActive || _this.markerActiveIcon);

        });

        markerReference.addListener('mouseout', function () {

            if (_this.activeMarker != markerReference) {

                _this.setMarkerIcon(markerReference, markerReference.iconsSettings.iconDefault || _this.markerDefaultIcon);
            }

        });

    };

    FinderMarkers.prototype.getMarkerByContentId = function (contentId) {
        return this.getMarkers(true).filter(function (marker) {
            return marker.contentId == contentId
        })[0]
    };

    FinderMarkers.prototype.disableMarker = function (marker) {
        marker.clickable = false;
    };

    FinderMarkers.prototype.setActive = function (marker) {

        this.setMarkerIcon(marker, marker.iconsSettings.iconActive || this.markerActiveIcon);

    };

    FinderMarkers.prototype.clearAllSelected = function () {

        if (this.activeMarker) {
            this.setMarkerIcon(this.activeMarker, this.activeMarker.iconsSettings.iconDefault || this.markerDefaultIcon);
        }

    };

    FinderMarkers.prototype.showContent = function (markerId) {

        this.emit('finder.markers.showContent', markerId);

    };

    FinderMarkers.prototype.hideContent = function () {

        this.emit('finder.markers.hideContent');

    };

    FinderMarkers.prototype.setMarkerIcon = function (markerReference, iconUrl) {

        markerReference.setIcon(iconUrl);

    };

    return FinderMarkers;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finderMarkers.js